<template>
    <ModalFormCard class="modal-default lg:min-w-[720px]" :action="action">
        <template #title>{{ showCreate ? "Create SMS template" : "Edit SMS template" }}</template>

        <template #default="{ saving }">
            <div class="grid grid-cols-2 gap-4">
                <Input name="name" label="Name" class="col-span-2" v-model:value="value.name" />

                <Select
                    name="group"
                    label="Category"
                    :options="groupOptions"
                    v-model:value="value.group"
                />

                <Input name="order" label="Order" v-model:value="value.order" />

                <Textarea
                    name="body"
                    label="Body"
                    rows='10'
                    class="col-span-2"
                    v-model:value="value.body"
                />

                <InputCheckbox
                    class="col-span-2 mt-2"
                    name="enabled"
                    value="1"
                    :checked="value.enabled"
                    @clicked="value.enabled = !value.enabled"
                >
                    <p class="pl-2 text-14">Enabled</p>
                </InputCheckbox>
            </div>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
                    {{ showCreate ? "Create SMS template" : "Save SMS template" }}
                </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from "~/mixins/modal.js"

export default {
    mixins: [Modal],

    data() {
        return {
            value: {
                name: "",
                group: "",
                order: "",
                body: "",
                enabled: false,
            },
        }
    },

    created() {
        this.action = this.isEdit
            ? `/admin/sms-template/${this.editingModel.id}`
            : "/admin/sms-template"

        if (this.editingModel) {
            this.value.name = this.editingModel.name ?? ""
            this.value.group = this.editingModel.group ?? ""
            this.value.order = this.editingModel.order ?? ""
            this.value.body = this.editingModel.body ?? ""
            this.value.enabled = [true, 1, "1"].includes(this.editingModel.enabled)
        }
    },

    computed: {
        showCreate() {
            return !this.isEdit
        },

        groupOptions() {
            return [
                { value: "", html: "" },
                { value: "Onboarding", html: "Onboarding" },
                { value: "Sales", html: "Sales" },
                { value: "Customer", html: "Customer" },
                { value: "Reviews", html: "Reviews" },
                { value: "Customers", html: "Customers" },
                { value: "Launched", html: "Launched" },
            ]
        },
    },
}
</script>
